var _style, _defs, _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFCD53;}\n\t.st1{clip-path:url(#SVGID_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#ED5565;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#ED5565;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 40,
    r: 40
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.8,0h97.4c6,0,10.8,4.9,10.8,10.9v58.2c0,6-4.8,10.9-10.8,10.9H10.8C4.8,80,0,75.1,0,69.1V10.9 C0,4.9,4.8,0,10.8,0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 119,
    height: 17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 63,
    className: "st1",
    width: 119,
    height: 17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.5,29.8c-3.6,0-5.5-2.6-5.5-2.6s-1.9,2.6-5.5,2.6c-3.3,0-5.5-2.1-5.5-2.1v13.9C12,50.7,23,54.5,23,54.5 s11-3.8,11-12.9V27.7C34,27.7,31.8,29.8,28.5,29.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEs);
export default __webpack_public_path__ + "static/media/es.96734bd547363cd0953e0e108ea19b98.svg";
export { ForwardRef as ReactComponent };